import { createSignal, createEffect } from "solid-js";
import { Icon } from '@iconify-icon/solid';
import { Button } from "@/components/shadcn/button";

import './ImageUploader.scss';

export default function ImageUploader(props) {

  const [path, setPath] = createSignal('');
  const [photo, setPhoto] = createSignal(null);

  const dispatchEvent = (newPhoto) => {
    setPhoto(newPhoto);
    if (photo() === null) {
      setPath(props.placeholder);
    } else {
      setPath(URL.createObjectURL(photo()));
    }

    props.onPhotoChanged(photo());
  }

  const photoChanged = (e) => {
    var input = e.target;
    if (!(input.files && input.files[0])) {
      return;
    }

    dispatchEvent(input.files[0]);
  }

  const resetPhoto = () => {
    if (props.placeholder === path()) {
      return;
    }

    dispatchEvent(null);
  }

  createEffect(() => {
    props.placeholder;
    setPath(props.placeholder);
  });

  return (
    <div class="w-full p-2 flex flex-col items-center">
      <img src={path()} class="border border-light" style={{ "max-width": props.width, "max-height": props.height, height: "auto", width: "100%", "object-fit": "contain" }} alt="Photo Uploader Placeholder" />
      <div class="mt-4">
        <button type="button" class="btn-file py-0 me-2">
          <Button class="bg-gray-200 dark:bg-gray-900 text-black dark:text-white shadow hover:bg-gray-100" as={innerProps => <span {...innerProps} />}>
            <Icon icon="lucide:upload" /> {props.uploadBtnText}
          </Button>
          <input type="file" ref="fileupload" onChange={photoChanged} accept=".png,.bmp,.gif,.jpg,.jpeg" />
        </button>
        <Button onClick={resetPhoto} variant="ghost" class="bg-gray-200 dark:bg-gray-900">
          <Icon icon="carbon:reset" /> {props.resetBtnText}
        </Button>
      </div>
    </div>
  );
}
